import React from "react";
import PasteListStepper from "./PasteListStepper";
import pasteListIcon from "../assets/pastelist.jpeg";

export default function PasteListFlowHeader({ currentStep = 1 }) {
  return (
    <div className="w-full border-b border-[#E6EAF0] bg-white">
      <div className="bg-[#0d9499] px-3 py-4 sm:px-6 sm:py-5">
        <div className="mx-auto flex max-w-7xl items-center gap-3">
          <img
            src={pasteListIcon}
            alt=""
            className="h-10 w-10 shrink-0 rounded-lg object-cover sm:h-12 sm:w-12"
            aria-hidden
          />
          <div className="flex min-w-0 flex-col gap-0.5 sm:flex-row sm:items-center sm:gap-4">
            <h1 className="text-[22px] font-medium uppercase tracking-wide text-white sm:text-[28px]">
              Paste List
            </h1>
            <p className="text-[16px] font-normal text-white/85 sm:mt-0.5 sm:text-[18px]">
              (Basket-led automatic comparison)
            </p>
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-6xl px-3 py-4 sm:px-6 sm:py-5">
        <PasteListStepper currentStep={currentStep} />
      </div>
    </div>
  );
}
